import { render, staticRenderFns } from "./imgStatus.vue?vue&type=template&id=eb60e040&scoped=true&"
import script from "./imgStatus.vue?vue&type=script&lang=js&"
export * from "./imgStatus.vue?vue&type=script&lang=js&"
import style0 from "./imgStatus.vue?vue&type=style&index=0&id=eb60e040&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb60e040",
  null
  
)

export default component.exports